import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {merge, Observable, Subscription, timer} from 'rxjs';
import {debounce, distinctUntilChanged, filter, map} from 'rxjs/operators';
import {ProductModel} from '../../classes/product.model';
import {ProductsService} from '../../services/products.service';
import {HEIGHT_ANIMATION, SMALL_DIALOG, trackByFn} from '@ft/core';
import {assign, get, isNil, noop} from 'lodash';
import {MatDialog} from '@angular/material/dialog';
import {ProductUpdateDialog} from '../../dialogs/product-update/product-update.dialog';
import {CertificateDialog} from '../../dialogs/certificate/certificate.dialog';

@Component({
    selector: 'ftm-product-detail',
    templateUrl: './detail.component.html',
    animations: [
        HEIGHT_ANIMATION
    ],
    styleUrls: ['./detail.component.scss']
})
export class ProductDetailComponent implements OnInit, OnDestroy {
    public product: ProductModel;
    public trackByFn = trackByFn('label');

    private subscription: Subscription;

    constructor(
        private _router: Router,
        private _dialog: MatDialog,
        private _route: ActivatedRoute,
        private _service: ProductsService
    ) {
    }

    get hasProduct() {
        return !isNil(this.product);
    }

    get obligatoryLicensePolicy() {
        return this._service.obligatoryLicensePolicy;
    }

    get demoUse() {
        return this._service.demoUse;
    }

    private get _routerEvents(): Observable<ProductModel> {
        const routerParams = this._route.params;
        const routerEvent = this._router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        );

        return merge(routerEvent, routerParams, this._service.products$)
            .pipe(
                debounce(() => timer(0)),
                map(() => this._service.products$.getValue().find(
                    item => item.id === parseInt((this._route.params as any).value.id, null)
                ))
            );
    }

    ngOnInit() {
        this.subscription = this._routerEvents
            .pipe(
                filter(product => this._router.url.startsWith(product.path)), distinctUntilChanged()
            )
            .subscribe(product => {
                this.product = product;
                this._service.currentProduct$.next(product);
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    updateProduct() {
        const dialogRef = this._dialog.open(ProductUpdateDialog, assign(SMALL_DIALOG, {
            data: {product: this.product}
        }));

        dialogRef.afterClosed().subscribe(
            data => {
                if (data) {
                    this.product = data;
                    this._service.currentProduct$.next(data);
                }
            }
        );
    }

    updateLicenseProduct() {
        this._service.showPackageLicenseDialog(this.product).afterClosed().subscribe(
            data => {
                if (data) {
                    // window.location.reload();
                    const currentUrl = this._router.url;
                    this._router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                        this._router.navigate([currentUrl]).then(noop, noop);
                    });
                }
            }
        );
    }

    updateCertificate() {
        this._dialog.open(CertificateDialog, SMALL_DIALOG);
    }
}
